<div class="localization-index-container">
  <div class="header-section">
    <h2>Localization Tables</h2>
    <p>Manage translations across all game content</p>
  </div>

  <div class="search-section">
    <span
      class="p-input-icon-left"
      [class.p-input-icon-right]="!!searchTerm">
      <i class="pi pi-search search-icon"></i>
      <input
        #searchInput
        type="text"
        pInputText
        [(ngModel)]="searchTerm"
        (input)="filterTables()"
        placeholder="Search tables..."
        class="search-input" />
      <i
        *ngIf="searchTerm"
        class="pi pi-times clear-icon"
        (mousedown)="$event.preventDefault()"
        (click)="clearSearch(); searchInput.focus()"></i>
    </span>
    <div class="results-info">
      <span>{{ filteredTables.length }} of {{ allTables.length }} tables</span>
    </div>
  </div>

  <div *ngIf="loading" class="loading-section">
    <p-progressSpinner></p-progressSpinner>
  </div>

  <div *ngIf="!loading" class="tables-list">
    <p-table 
      [value]="filteredTables" 
      [paginator]="true" 
      [rows]="20"
      [rowsPerPageOptions]="[10, 20, 50, 100]"
      [responsive]="true">
      <ng-template pTemplate="header">
        <tr>
          <th>Table Name</th>
          <th style="width: 150px; text-align: center">Records</th>
          <th style="width: 120px; text-align: center">Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-table>
        <tr class="table-row">
          <td>
            <span class="table-title">{{ table.title }}</span>
          </td>
          <td style="text-align: center">
            <span class="record-count" *ngIf="table.recordCount !== undefined">
              {{ table.recordCount }}
            </span>
            <span class="record-count-loading" *ngIf="table.recordCount === undefined">
              <i class="pi pi-spin pi-spinner"></i>
            </span>
          </td>
          <td style="text-align: center">
            <button 
              pButton 
              type="button" 
              label="Open" 
              icon="pi pi-external-link"
              class="p-button-sm p-button-outlined"
              (click)="navigateToTable(table.route)">
            </button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="3" style="text-align: center; padding: 2rem;">
            <i class="pi pi-search" style="font-size: 2rem; color: var(--text-color-secondary);"></i>
            <p style="margin-top: 1rem; color: var(--text-color-secondary);">
              No tables found matching "{{ searchTerm }}"
            </p>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

